import {
  PaymentComponentConfig,
  PaymentComponentCreateBindCardOptions,
  PaymentComponentCreateDropinOptions,
  PaymentComponentCreateLinkOptions,
} from '../types'
import { PaymentComponentDropin } from './dropin'
import { PaymentOrderInfo, PublishPaymentMethodItem } from '@web-publish-id/payment-shared/apis/types/payment'
import type { PaymentComponentCore } from '../core'
import { getPaymentOrderInfo } from '@web-publish-id/payment-shared/apis/payment'
import PaymentComponentLink from './link'
import { bizApiWrapper } from '@web-publish-id/shared/http'
import { PaymentComponentBindCard } from './bindCard'

/**
 * 支付组件
 */
export class PaymentComponent {
  core: PaymentComponentCore
  config: PaymentComponentConfig
  orderInfo: PaymentOrderInfo

  constructor(core: PaymentComponentCore, config: PaymentComponentConfig) {
    this.core = core
    this.config = config
  }

  // 获取订单信息
  async getOrderInfo() {
    const { sys_order_id } = this.config
    const res = await bizApiWrapper(getPaymentOrderInfo({ sys_order_id }))

    if (res.data) {
      this.orderInfo = res?.data?.order_info
    }

    return res
  }

  /**
   * 创建dropin
   */
  createDropin(methodConfig: PublishPaymentMethodItem, options: PaymentComponentCreateDropinOptions) {
    this.assertPaymentType(2, methodConfig)

    const method = new PaymentComponentDropin(this, methodConfig, options)

    return method
  }

  /**
   * 创建链接支付
   */
  createLink(methodConfig: PublishPaymentMethodItem, options: PaymentComponentCreateLinkOptions) {
    this.assertPaymentType(1, methodConfig)

    const method = new PaymentComponentLink(this, methodConfig, options)

    return method
  }

  /**
   * 创建绑定卡
   */
  createBindCard(methodConfig: PublishPaymentMethodItem, options: PaymentComponentCreateBindCardOptions) {
    this.assertPaymentType(2, methodConfig) // 2-dropin

    const method = new PaymentComponentBindCard(this, methodConfig, options)

    return method
  }

  // 支付类型断言判断
  private assertPaymentType(type: number, methodConfig: PublishPaymentMethodItem) {
    if (methodConfig.payment_type !== type) {
      throw new Error('Payment type mismatch')
    }

    return true
  }
}

export default PaymentComponent
